import { mergeToNewObject } from '../../../util/helpers'
import { PASSWORD_CHANGE } from '../../../constants/actions'

export const pwdChangeProfile = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case PASSWORD_CHANGE.ON_PASSWORD_CHANGE:
      return mergeToNewObject(state, { password: payload })

    case PASSWORD_CHANGE.ON_REPEAT_PASSWORD_CHANGE:
      return mergeToNewObject(state, { repeatPassword: payload })

    case PASSWORD_CHANGE.ON_PASSWORD_CHANGED_ACTION:
      return mergeToNewObject(state, { passwordChanged: true })

    case PASSWORD_CHANGE.ON_RESET_STATE:
      return INITIAL_STATE

    default:
      return state
  }
}

const INITIAL_STATE = {
  password: '',
  repeatPassword: '',
  passwordChanged: false
}



// WEBPACK FOOTER //
// ./src/store/reducers/wallet/passwordChange.js